import * as React from 'react';

import SVGIcon from 'components/svg-icon/SVGIcon';

import { __t, applyTranslations } from 'utils/language';
import { getFormattedFollowersValue, getNumFollowers } from 'utils/influencers';
import { getFormattedPercentageRate } from 'utils/formatters';

import './tile-standard-tabs-popover.scss';

import type { Metrics, TabsSectionType } from 'types';

applyTranslations(require('locales/common/collabary-common.i18n.json'));
applyTranslations(require('../tile-standard-tabs.i18n.json'));

type Props = {
  identifier: string,
  type?: TabsSectionType,
  metrics?: Metrics,
  icons: Array<string>
};

const COMMON_MSG_KEY = 'collabary_common';
const MSG_KEY = 'tile_standard_tabs';

const TileStandardTabsPopover = (
  {
    type,
    identifier,
    metrics,
    icons
  }: Props
): JSX.Element => {
  const renderMetric = (metricType: 'followers' | 'engagement_rate', value: string): JSX.Element => (
    <div className="tile-standard-tabs-popover__metric">
      <div className="tile-standard-tabs-popover__metric-label">
        {__t(`${MSG_KEY}.labels.${metricType}`)}:
      </div>
      <div>
        {value}
      </div>
    </div>
  );

  const renderResidual = (): JSX.Element => (
    <div className="tile-standard-tabs-popover__residual">
      {
        icons.map(icon => (
          icon && (
            <div
              key={`tile-standard-tabs-popover__icon--${icon}`}
              className="tile-standard-tabs-popover__icon"
              title={__t(`${COMMON_MSG_KEY}.social.${icon}`)}
            >
              <SVGIcon
                key={`tile-standard-tabs-popover__icon--${icon}`}
                name={`${icon}-no-customisation`}
                width={24}
                height={24}
              />
            </div>
          )
        ))
      }
    </div>
  );

  const renderMain = (): JSX.Element => {
    const numFollowers = getNumFollowers(metrics?.followers || 0);
    const formattedFollowers = getFormattedFollowersValue(numFollowers);
    const formattedPercentage = getFormattedPercentageRate(metrics?.engagementRate);

    return (
      <div className="tile-standard-tabs-popover__main">
        <div className="tile-standard-tabs-popover__channel">
          {__t(`${COMMON_MSG_KEY}.social.${identifier}`)}
        </div>
        {renderMetric('followers', formattedFollowers)}
        {renderMetric('engagement_rate', formattedPercentage)}
      </div>
    );
  };

  return (
    <div className="tile-standard-tabs-popover">
      {
        type === 'main'
          ? renderMain()
          : renderResidual()
      }
    </div>
  );
};

export default TileStandardTabsPopover;
